function Dot(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={9} cy={9} r={7.5} fill="#EBECED" stroke="#fff" strokeWidth={3} />
    </svg>
  )
}

export default Dot
